import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../api/auth";
import "./Login-ForgotPassword-ResetPassword.css";
import { useAuthUser } from "../components/dashboard/hooks/useAuthUser";

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuthUser();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const whereToNavigate = user ? "/profile" : "/login";
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (!formData.email) {
      setError("Email is required");
      return;
    }

    try {
      setLoading(true);
      const res = await forgotPassword({ email: formData.email });
      setMessage(res?.message || "A reset link has been sent.");
    } catch (err: any) {
      setError(
        err.response?.data?.message || "Failed to request password reset",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="wrapper-card pink">
          <div className="info-card login-content">
            <h2>Forgot Password?</h2>
            <p className="forgot-password-centered-text">
              Enter your email address to recieve an email where you can reset
              your password.
            </p>

            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}

            <form onSubmit={handleSubmit} className="login-form">
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />

              <button
                id="login-btn"
                type="submit"
                className="btn"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>

              <button
                type="button"
                className="no-style-btn"
                onClick={() => navigate(whereToNavigate)}
                disabled={loading}
              >
                {user ? "Back to profile" : "Back to Login"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
